// src/components/artist-list/artist-list.js
import React, { Component } from 'react'
import AppLink from '../app-link'
import insertBreak from '../../lib/insertBreak'
import './artist-list.css'

class ArtistList extends Component {
  getMarkupTitle(item) {
    let str = ''

    if (item) {
      const { title } = item
      str = insertBreak(title, '&#038;')
    }

    return {
      __html: str
    }
  }
  
  renderArtists(artists) {
    const { onArtistClick } = this.props
    return artists.map(item => {
      return (
        <li key={item.id}  className="artist__list-item">
          <AppLink onClick={onArtistClick} className="artist__link" to={`/artists/${item.slug}`}>
            <span className="artist__link-content text--headline" dangerouslySetInnerHTML={this.getMarkupTitle(item)} />
          </AppLink>
        </li>
      )
    })
  }

  renderArtistGroup(groups) {
    return Object.keys(groups).map((key, index) => {
      return (
        <div key={index} className="artist__group">
          <div
            className="artist__category text--small"
            dangerouslySetInnerHTML={{ __html: key }}
          />
          <ul className="artist__list">
            {groups[key] && this.renderArtists(groups[key])}
          </ul>
        </div>
      )
    })
  }
  
  render() {
    const { artists } = this.props

    return (
      <div className="artist-list">
        <div className="artist__section">
          {artists && this.renderArtistGroup(artists)}
        </div>
      </div>
    )
  }
}

export default ArtistList



// WEBPACK FOOTER //
// ./src/components/artist-list-container/artist-list.js